export const getCurrentUrlWithoutProtocol = (): string => {
    const { hostname } = window.location;
    return hostname;
}